<template>
	<LoadingBar
		v-if="overviewData.inventarisation.loading && !overviewData.inventarisation.data.percentage"
	/>

	<EmptyStatePlaceholder
		v-else-if="showPlaceholder"
		title="Inventariseer risico's"
		description="Beantwoord de vragen en maak een actieplan"
		image="empty-dashboard"
	>
		<BaseButton
			v-if="!readOnly"
			text="Start inventarisatie"
			:to="{name: pageNames.inventarisation, params: {companyId, rieId}}"
		/>
	</EmptyStatePlaceholder>

	<template v-else>
		<DashboardOverview
			:read-only="readOnly"
			:company-id="companyId"
			:rie-id="rieId"
			:data="overviewData"
		/>

		<DashboardActionOverview
			:actions="overviewData.actions.data.openActions"
			:loading="overviewData.actions.loading"
			data-testid="widget-planning"
		/>
	</template>
</template>
<script setup lang="ts">
	import {computed} from 'vue';
	import type {PropType} from 'vue';
	import {pageNames} from '~/lib/pageHelper';
	import EmptyStatePlaceholder from '~/components/generic/EmptyStatePlaceholder.vue';
	import BaseButton from '~/components/generic/buttons/BaseButton.vue';
	import DashboardActionOverview from '~/components/dashboard/DashboardActionOverview.vue';
	import LoadingBar from '~/components/generic/LoadingBar.vue';
	import DashboardOverview from '~/components/dashboard/DashboardOverview.vue';
	import type {DashboardOverviewData} from '~/lib/types/dashboardTypes';

	const props = defineProps({
		overviewData: {
			type: Object as PropType<DashboardOverviewData>,
			required: true
		},
		companyId: {
			type: Number,
			required: true
		},
		rieId: {
			type: String,
			required: true
		},
		readOnly: {
			type: Boolean,
			default: false
		}
	});

	/**
	 * Show placeholder when user has not started using the RIE.
	 * We can check this by looking at the inventarisation percentage in combination with the total amount of risks.
	 * If both are 0, the user has not started using the RIE. Not in a way that has meaningful impact at least.
	 */
	const showPlaceholder = computed(() => {
		return props.overviewData &&
			!props.overviewData.inventarisation.loading &&
			props.overviewData.inventarisation.data.percentage === 0 &&
			props.overviewData.risks.data.total === 0;
	});
</script>
